import { Clock, ListMusic, Sparkles } from 'lucide-react';
import { nextEventContactPath } from '../../utils/endOfShow';

interface EventMissedViewProps {
  eventId: string;
  eventName: string;
  onSeePlaylist: () => void;
}

// For people who never took part in an event that has ended (ITER-199)
export function EventMissedView({ eventId, eventName, onSeePlaylist }: EventMissedViewProps) {
  return (
    <div className="min-h-screen flex items-center justify-center p-6" data-testid="event-missed-view">
      <div className="w-full max-w-md text-center space-y-6">
        <div>
          <div className="w-20 h-20 mx-auto bg-gray-100 dark:bg-gray-800 rounded-full flex items-center justify-center mb-6">
            <Clock className="w-10 h-10 text-gray-400" />
          </div>
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Sorry you missed this one!</h1>
          <p className="text-gray-600 dark:text-gray-400">{eventName} has ended.</p>
        </div>
        <div className="space-y-2">
          <a
            href={nextEventContactPath(eventId, 'missed-it')}
            className="btn btn-primary w-full flex items-center justify-center gap-2"
          >
            <Sparkles className="w-4 h-4" />
            Learn more about VoteBeats
          </a>
          <button type="button" onClick={onSeePlaylist} className="btn btn-secondary w-full flex items-center justify-center gap-2">
            <ListMusic className="w-4 h-4" />
            See tonight&rsquo;s playlist
          </button>
        </div>
      </div>
    </div>
  );
}
